export const removeFileExtension = (fullFileName) => {
  const fileNameArray = fullFileName.split('.');
  return fileNameArray.slice(0, fileNameArray.length - 1).join('.');
};

export const sanitizeText = (word) => word.toString().toLowerCase().trim();

export const formatPrice = (price) => {
  return new Intl.NumberFormat('en-CA', {style: 'currency', currency: 'CAD'}).format(price);
};